import React from "react"

import Layout from "../components/layout";
import SEO from "../components/seo"

const Contact = () => (
  <Layout>
    <SEO title="Contact Vue Vixens" />
    <h1>Contact Page</h1>
    <p>Welcome to the site, and thanks for getting in touch!</p>
  </Layout>
);

export default Contact;